export const TESTIMONIAL_SHOW_RESET = 'TESTIMONIAL_SHOW_RESET';
export const TESTIMONIAL_SHOW_SET_ERROR = 'TESTIMONIAL_SHOW_SET_ERROR';
export const TESTIMONIAL_SHOW_SET_RETRIEVED = 'TESTIMONIAL_SHOW_SET_RETRIEVED';
export const TESTIMONIAL_SHOW_TOGGLE_LOADING = 'TESTIMONIAL_SHOW_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/testimonial/show/mutation_types.js